import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import SideMenuV2 from '../menu/SideMenuV2';

import Kullanicilariservice from "../service/IkIseAlimKullanicilariService";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AppRoutes from '../util/AppRoutes';
import { useCookies } from 'react-cookie';
import Moduleservice from '../service/GeneralServices/ModuleService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const HomePage = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [pinned, setPinned] = useState(true);
    const [Routers, setRouters] = useState([]);
    const { user } = useSelector(state => state.auth);


    //const [cookies] = useCookies(['module']);
    const [defMoudel, setDefMoudel] = useState(null);

    const [modules, setModules] = useState([]);

    const onMenuToggle = (pin) => {
        setPinned(pin);
        const content = document.getElementById('content');
        const toolbar = document.getElementById('fixedToolBar');

        if (content && toolbar) {
            if (pin) {
                content.classList.add("expanded");
                toolbar.classList.add("expanded");
            } else {
                content.classList.remove("expanded");
                toolbar.classList.remove("expanded");
            }
        } else {
            console.warn("Content or toolbar elements not found in the DOM.");
        }
    };

    const fetchRoutes = async (module) => {
        const result = await Kullanicilariservice.getKullaniciYetkisi({ id: user.id, moduleId: module });
        if (result.isSuccess) {
            setRouters(result.resultObject);
        }
    };


    useEffect(() => {
        let isMounted = true; // Track if the component is mounted
        Moduleservice.get().then((res) => {
            if (res.isSuccess) {
                setModules(res.resultObject);


                if (!user?.module) {
                    const moduleId = res.resultObject.find(r => r.isSysDefault == true)?.id;
                    setDefMoudel(moduleId);
                    fetchRoutes(moduleId);
                } else {
                    const moduleId = res.resultObject.find(r => r.id == user?.module)?.id;
                    setDefMoudel(moduleId);
                    fetchRoutes(moduleId);
                }


            }
        });
        return () => {
            isMounted = false; // Cleanup: Mark component as unmounted
        };
    }, []); // Fetch only depends on the user ID

    useEffect(() => {
        onMenuToggle(pinned);
    }, [pinned]);

    const onModuleChange = (value) => {
        Kullanicilariservice.getKullaniciYetkisi({ id: user.id, moduleId: value }).then((res) => {
            if (res.isSuccess) {
                setRouters(res.resultObject);

                const pageurl = modules.find(r => r.id == value)?.yol;
                history.push(pageurl ?? "/");
            }
        })

    }

    return (
        <div className="App">
            <SideMenuV2
                onToggle={onMenuToggle}
                pinned={pinned}
                Routers={Routers}
                moduleChange={onModuleChange}
                defMoudel={defMoudel}
                modules={modules}
            />
            <AppRoutes routers={Routers} />
        </div>
    );
};

export default withRouter(HomePage);
